import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import * as T from 'utils/types';


const urlQuery = new URLSearchParams(window.location.search);

const search_urlQuery = urlQuery.get('search');

export const initialState: T.SearchBlockState = {
    searchInput_internal: search_urlQuery ? search_urlQuery : '',
}

// searchBlockS: searchBlockSlice
export default createSlice({
    name: 'searchBlock',
    initialState,
    reducers: {
        reset: ()=>initialState,
        setSearchInput_internal: (state, action: PayloadAction<string>) => {
            state.searchInput_internal = action.payload;
        },
    }
});

